/**
 * LaunchDarkly key: `DashboardRevamp`.
 * ON = DashboardRevamp, OFF/absent = original Dashboard-v2.
 *
 * Checks both casings — the LD React SDK camelCases keys by default
 * (`dashboardRevamp`), while the dashboard key may arrive as `DashboardRevamp`.
 */
export const isDashboardRevampEnabled = (flags?: {
  DashboardRevamp?: boolean;
  dashboardRevamp?: boolean;
}): boolean => Boolean(flags?.DashboardRevamp ?? flags?.dashboardRevamp);

export default isDashboardRevampEnabled;
